define('TescoMobile_Eecc/js/action/save-form',['jquery'], function ($) {
  'use strict';

  return function (formSelector) {
    const $form = $(formSelector);
    const $body = $('body');
    $body.loader('show');
    return $.ajax({
      url: $form.attr('action'),
      data: $form.serialize(),
      type: 'post'
    }).always(function () {
      $body.loader('hide');
    });
  };
});

